<template>
    <div class="flex flex-col justify-items-center">
        <button class="text-lg text-gray-400 hover:text-accented focus:outline-none" type="button" @click="addMinutes(5)"><icon name="chevron-up"/></button>
        <span v-text="timeStr"></span>
        <button class="text-lg text-gray-400 hover:text-accented focus:outline-none" type="button" @click="addMinutes(-5)"><icon name="chevron-down"/></button>
    </div>
</template>

<script>
export default {
    props: [
        'value',
        'max',
        'min'
    ],

    data() {
        return {
            time: this.value,
            timeStr: null
        }
    },

    methods: {
        addMinutes(value) {
            try {
                let newMinutes = this.time.getMinutes() + value;
                let newTime = (new Date(this.time.getTime())).setMinutes(newMinutes);

                if (this.max instanceof Date && newTime >= this.max) {
                    throw new RangeError();
                }
                if (this.min instanceof Date && newTime <= this.min) {
                    throw new RangeError();
                }

                this.time.setMinutes(newMinutes);
                this.$emit('input', this.time);
                this.timeStrRefresh();
            } catch (e) {
                Notify.swal({
                    icon: 'error',
                    title: 'Konec nemůže být dřív než začátek'
                });
            }
        },
        timeStrRefresh() {
            let minuesWithLeadingZero = ('0' + this.time.getMinutes()).slice(-2);
            this.timeStr = `${this.time.getHours()}:${minuesWithLeadingZero}`;
        },
    },

    mounted() {
        this.timeStrRefresh();
    }
}
</script>
